<mat-card class="notification" [class.mat-accent]="data.type==='success'" [class.mat-primary]="data.type==='info'" [class.mat-warn]="data.type==='warn'">
  <mat-card-subtitle class="notification-title">
    {{data.title}}
    <span style="flex: 1 1 1e-09px;"></span>
    <button mat-icon-button>
      <mat-icon (click)="action()">close</mat-icon>
    </button>
  </mat-card-subtitle>
  <mat-card-content class="notification-content" [innerHTML]="data.message"></mat-card-content>
</mat-card>